import React, { Component } from 'react';
import { Modal, Row, Col, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import dropin from 'braintree-web-drop-in';
import FontAwesome from 'react-fontawesome';
import loader from '../../assets/loader.svg';
import moment from 'moment';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import {
  BRAINTREE_LEGAL_PAGE_URL,
  COSYND_CONTACT_PAGE_URL,
} from '../../constants';

const backdropStyle = {
  position: 'fixed',
  zIndex: 1040,
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: '#000',
  opacity: 0.5,
};

class ReviewCheckoutModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      instance: null,
      loading: false,
      price: '',
      orderTitle: '',
      payLoading: false,
    };
  }

  componentWillMount() {
    const { planType, referrer } = this.props;

    this.setState({ loading: true });
    this.props.getClientToken();

    this.setValues({ planType, referrer });
  }

  componentWillReceiveProps(nextProps) {
    const { status, planType, referrer } = nextProps;

    if (status !== this.props.status) {
      if (status === actionTypes.PAYMENT_SUBSCRIBE_SUCCESS) {
        this.props.loadProfile();
        this.props.onPaySuccess();
        this.setState({ payLoading: false });
      } else if (status === actionTypes.PAYMENT_TRANSACTION_ERROR) {
        this.props.alert('error', 'Payment failed. Please try again');
      }
    }

    this.setValues({ planType, referrer });
  }

  setValues({ planType, referrer }) {
    let price = 0;
    let orderTitle = 'Free';
    const priceTitle = 'year';

    if (planType === 'premium') {
      if (referrer.includes('cdbaby') || referrer.includes('soundrop')) {
        price = 150;
      } else if (referrer.includes('bmi')) {
        price = 130;
      } else {
        price = 150;
      }

      orderTitle = 'Premium Plan';
    }

    this.setState({ price, orderTitle, priceTitle });
  }

  componentDidUpdate(prevProps, prevState) {
    const { clientToken } = this.props;
    const { instance } = this.state;

    if (clientToken && !instance && this.dropinRef) {
      dropin.create(
        {
          authorization: clientToken,
          container: '#dropin-container',
          card: {
            overrides: {
              fields: {
                number: {
                  maskInput: {
                    showLastFour: true,
                  },
                },
                expirationDate: {
                  placeHolder: 'MM/YY',
                },
                cvv: {
                  maskInput: true,
                },
              },
            },
          },
        },
        (err, instance) => {
          if (err) {
            console.log('BraintreeError: ', err);
          } else {
            this.setState({ loading: false, instance });
          }
        }
      );
    }
  }

  renderBackdrop(props) {
    return <div {...props} style={backdropStyle} />;
  }

  payNow() {
    const { instance } = this.state;
    const { planType, referrer } = this.props;
    let plan_id = `${planType}-annual`;

    // if (referrer.includes('cdbaby') || referrer.includes('soundrop')) {
    //     plan_id = `${planType}-annual-cdbaby`;
    // }

    if (referrer.includes('bmi')) {
      plan_id = `${planType}-annual-bmi`;
    }

    // Process purchase and create transaction
    if (instance) {
      this.setState({ payLoading: true }, () => {
        this.props.alert(
          'info',
          'Payment is processing, please do not refresh page.'
        );
      });

      instance.requestPaymentMethod((err, payload) => {
        if (err) {
          console.error(err);
          this.setState({ payLoading: false });
        } else {
          this.props.subscribe({ nonce: payload.nonce, plan_id });
        }
      });
    }
  }

  render() {
    const { show } = this.props;
    const { loading, payLoading, price, orderTitle, priceTitle } = this.state;
    const today = moment().format('MMMM Do YYYY');

    return (
      <Modal
        dialogClassName="user-plan-modal review-checkout-modal"
        show={show}
        onHide={() => this.props.onHide()}
        onExited={() => this.props.onExited()}
        renderBackdrop={this.renderBackdrop}
      >
        <Modal.Header closeButton>
          <div className="modal-title">Review and Checkout</div>
        </Modal.Header>

        <Modal.Body>
          <Row className="checkout-row">
            <Col md={7} className="checkout-col">
              <div className="checkout-form">
                {loading && (
                  <div className="loader">
                    <img src={loader} alt="Loading spinner" />
                  </div>
                )}
                {!loading && (
                  <div className="checkout-desc">
                    Please complete the form below before proceeding.
                  </div>
                )}

                <div ref={(c) => (this.dropinRef = c)} id="dropin-container" />

                {!loading && (
                  <div>
                    <p>
                      Your data is encrypted and securely stored by Braintree, a
                      PayPal service.&nbsp; You may view Braintree's security
                      policies{' '}
                      <a href={BRAINTREE_LEGAL_PAGE_URL} target="_blank">
                        here
                      </a>
                      .
                    </p>
                    <br />
                    <p>
                      Having trouble subscribing? Contact us at{' '}
                      <a href={COSYND_CONTACT_PAGE_URL} target="_blank">
                        help@cosynd.com
                      </a>
                    </p>
                  </div>
                )}
              </div>
            </Col>
            <Col md={5} className="checkout-col">
              <div className="order-view">
                <div className="title">Please review your order:</div>
                <br />
                <div className="Plan-title">{orderTitle}</div>
                <div>
                  ${price}/{priceTitle}
                </div>
                <br />
                <div>
                  Create unlimited split sheets, work for hire, producer and
                  collaboration agreements, as well as file up to four copyright
                  registrations for free (just pay federal filing fees).
                </div>
                <br />
                <div className="title">Billing Conditions</div>
                <p>
                  You are agreeing to a annual subscription service. This
                  subscription will automatically renew.&nbsp; You will be
                  charged ${price} today ({today}) and you will be charged $
                  {price} on the same day of each {priceTitle}, until you cancel
                  your subscription.
                </p>
                <p>
                  You can cancel your Cosynd subscription by clicking on "Edit
                  Profile".&nbsp; If you cancel within a billing cycle, your
                  membership stays active until the end of the billing cycle,
                  and you will not be billed for the following period.
                </p>
              </div>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <div className="checkout-footer">
            <button className="cancel" onClick={() => this.props.onCancel()}>
              Cancel
            </button>
            <div className="buttons">
              <div className="ssl-view">
                <FontAwesome name="lock" />
                <br />
                <div>SSL Encryption - Powered by&nbsp;</div>
                <a href={BRAINTREE_LEGAL_PAGE_URL} target="_blank">
                  Braintree
                </a>
              </div>
              <button className="back" onClick={() => this.props.onBack()}>
                Back
              </button>
              <Button
                className="pay-now"
                disabled={payLoading || loading}
                onClick={() => this.payNow()}
              >
                {payLoading ? 'Processing...' : 'Pay Now'}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  clientToken: state.payment.clientToken,
  status: state.payment.status,
  subscription: state.payment.subscription,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  getClientToken: () => {
    dispatch(actions.clientToken());
  },
  subscribe: (options) => {
    dispatch(actions.subscribe(options));
  },
  loadProfile: () => {
    dispatch(actions.getProfile());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReviewCheckoutModal);



// WEBPACK FOOTER //
// src/components/UserPlan/ReviewCheckoutModal.jsx